<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <div
          class="kds-typography-paragraph-large"
          v-html="descriptionText"
        />
        <h3
          class="kds-typography-title-xlarge"
          v-html="
            $t('b2b__self_test__physical_activity__msk_us__chores_header')
          "
        />
        <div
          class="kds-typography-paragraph-large"
          v-html="$t('b2b__self_test__physical_activity__msk_us__items_hint')"
        />
      </div>
      <div class="self-test">
        <fieldset>
          <div
            v-for="item in items"
            :key="item.key"
            :class="[
              'quiz-radio',
              { 'quiz-radio--checked': item.key === activityChores },
            ]"
            @click="handleRadioButtonChange(item)"
          >
            <label class="quiz-radio__label kds-typography-title-medium">
              {{ $t(item.value) }}
            </label>
            <div class="quiz-radio__layout">
              <custom-radio
                :checked="item.key === activityChores"
                :data-qa-value="`${item.key}`"
                :value="`${item.key}`"
                data-qa="physical-activity"
              />
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestReevaluationStore from '@shared/modules/assessment/stores/useSelfTestReevaluationStore.js'
import CustomRadio from '@shared/components/CustomRadio.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import physicalActivityDifficulties from '@shared/modules/assessment/config/physical-activity-difficulties.json'
import { useI18n } from 'petite-vue-i18n'
import { computed, ref } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'

const reevaluationsStore = useSelfTestReevaluationStore()
const { t } = useI18n()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const items = ref(physicalActivityDifficulties.concat([]))

const activityChores = computed(() => reevaluationsStore.activityChores)

const descriptionText = computed(() =>
  t('b2b__self_test__physical_activity__msk_us__description', {
    steps: '1/4',
  }),
)

const isValid = computed(() => activityChores.value > 0)

const handleRadioButtonChange = (item) => {
  reevaluationsStore.activityChores = item.key
}
</script>

<style lang="scss">
@use '@shared/modules/assessment/views/css/SelfTest.scss' as *;
</style>
